import { useBreakpoint } from '@/hooks/useBreakpoint'

export function useIsMobile() {
  const breakpoints = useBreakpoint()
  return !breakpoints.lg
}
